import { Link } from "gatsby";
import React, { Component } from "react";
import DownloadAndroid from "../../images/download_android.png";
import DownloadIOS from "../../images/download_ios.png";
import IlluStandOut from "../../images/illu_standout.png";
import Button from "../base/Button";
import Input from "../base/Input";

export default class HeroHome extends Component {
  render() {
    return (
      <div className="w-full">
        <div className="relative overflow-hidden">
          <main>
            <div className="pt-10 pb-24 sm:pb-40 bg-gray-100 sm:pt-16 lg:pt-8 lg:pb-14 lg:overflow-hidden">
              <div className="mx-auto max-w-7xl lg:px-8">
                <div className="lg:grid lg:grid-cols-2 lg:gap-8">
                  <div className="mx-auto max-w-md px-4 sm:max-w-2xl sm:px-6 sm:text-center lg:px-0 lg:text-left lg:flex lg:items-center">
                    <div className="lg:py-24">
                      <h1 className="mt-4 text-4xl tracking-tight font-extrabold text-gray-900 sm:mt-5 sm:text-6xl lg:mt-6 xl:text-6xl">
                        <span className="block">Volunteering As</span>
                        <span className="block text-red-600">A New Norm</span>
                      </h1>
                      <p className="mt-3 font-body text-base text-gray-700 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl">
                        MySukarela serves as a platform that connects volunteers
                        with non-profit organizations (NGO) to conduct
                        humanitarian tasks. Find volunteering projects nearby
                        you and get started volunteering now!
                      </p>
                      <div className="mt-10 sm:mt-12">
                        <form
                          action="#"
                          className="sm:max-w-xl sm:mx-auto lg:mx-0"
                        >
                          <div className="sm:flex">
                            <div className="min-w-0 flex-1">
                              <Input
                                placeholder="Email Address"
                                className="w-full"
                              />
                            </div>
                            <div className="mt-3 sm:mt-0 sm:ml-3">
                              <Link to="/auth/signUp">
                                <Button
                                  className="w-full"
                                  type="normal"
                                  text="Create An Account"
                                />
                              </Link>
                            </div>
                          </div>
                          <p className="mt-3 text-sm text-gray-700 font-body sm:mt-4">
                            Join MySukarela Family now ! By creating an account,
                            you agree to our{" "}
                            <Link
                              to="/terms"
                              className="font-bold font-display text-red-600 hover:text-red-500"
                            >
                              terms or service
                            </Link>
                            .
                          </p>
                          <div className="mt-4 sm:mt-0">
                            <a href="https://play.google.com/store/apps/details?id=com.mysukarela.app">
                              <img
                                src={DownloadAndroid}
                                className="h-12 w-44 mt-6 sm:mt-4 object-cover rounded"
                                alt="Play Store"
                              />
                            </a>
                            <a href="https://apps.apple.com/us/app/mysukarela/id1593829849">
                              <img
                                src={DownloadIOS}
                                className="h-12 w-44 mt-3 sm:mt-2 object-cover rounded"
                                alt="App Store"
                              />
                            </a>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  <div className="mt-6 -mb-16 sm:-mb-48 lg:m-0 lg:relative">
                    <div className="mx-auto max-w-md px-4 sm:max-w-2xl sm:px-6 lg:max-w-none lg:px-0">
                      <img
                        className="w-full lg:absolute lg:inset-y-0 lg:left-0 lg:h-full lg:w-auto lg:max-w-none"
                        src={IlluStandOut}
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    );
  }
}
